function DOMready(callback) {
  if (document.readyState != 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

DOMready(async function () {
  const productMain = document.querySelector('.product-info-wrapper')

  const initRecharge = () => {
    const wrapp = document.querySelectorAll(
      '.rc-container-wrapper.rc_container_wrapper'
    )
    if (wrapp.length > 0) window.ReChargeWidget.destroyAllWidgets()
    window.ReChargeWidget.createWidget(window.configRecharge)
    window.configRecharge.injectFn()

    // && window.ReChargeWidget.getWidget(window.configRecharge.productId) != undefined
    // if (window.scrollY > productMain.offsetHeight) {
    // if (window.matchMedia("(min-width: 1200px)").matches) {
    // const checkInitSticky = document.querySelector(`${window.configRechargeSticky.injectionParent} .rc-container-wrapper`);
    // if (checkInitSticky == null) {
    //   const wrapp = document.querySelectorAll(".rc-container-wrapper.rc_container_wrapper");
    //   console.log(wrapp)
    //   if (wrapp.length > 0) window.ReChargeWidget.destroyAllWidgets();
    //   window.ReChargeWidget.createWidget(window.configRechargeSticky);
    // }
    // }
    // } else {
    // if (wrapp.length > 0) window.ReChargeWidget.destroyAllWidgets()
    // window.ReChargeWidget.createWidget(window.configRecharge)
    // window.configRecharge.injectFn()
    // }

    // document.addEventListener('click', function (e) {
    // selectRecharge(e);
    // })

    // if (window.matchMedia("(min-width: 1200px)").matches) {
    // setTimeout(() => {
    //   if (stickyMenu != null) {
    //     document.addEventListener("scroll", function () {
    //       initStickyMenu();
    //     });
    //   }
    // }, 1000);
    // }
  }

  function waitFor(predicate) {
    return new Promise((resolve, reject) => {
      const check = () => {
        // console.log('checking', predicate())
        if (!predicate()) return
        clearInterval(interval)
        resolve()

        setTimeout(() => {
          initRecharge()
          // console.log('Recharge')
        }, 150)
      }
      const interval = setInterval(check, 100)
      check()
    })
  }

  await waitFor(() => window.ReChargeWidget)

  // function selectRecharge(e) {
  //   const elem = e.target
  //   const rcTemplate = document.querySelector('.p-sticky-menu .rc-template')

  //   if (rcTemplate == null) return

  //   if (elem.classList.contains('rc-template')) {
  //     rcTemplate.classList.add('active')
  //   } else {
  //     if (rcTemplate.classList.contains('active')) {
  //       rcTemplate.classList.remove('active')
  //     }
  //   }
  // }
})
